import { useEffect, useState } from "react";

const DataTable = ({
    header = [],
    rawData = [],
    search = "",
    sortBy = "",
    reverseSort = false,
    paginate = false,
    maxRow = 10,
    selectable = false,
    setSelectedRows,
}) => {
    const [displayData, setDisplayData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [pageNo, setPageNo] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [data, setData] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState([]);

    // returns filtered array with search
    function searchArrayOfObject(arr, searchKey) {
        return arr.filter((obj) =>
            Object.keys(obj).some((key) => obj[key]?.toString().toLowerCase().includes(searchKey.toLowerCase()))
        );
    }

    useEffect(()=>{
        let tempData = rawData.map((d,i) => ({...d,rowID : i})) ;   
        setSelectedRowIndex(new Array(tempData.length).fill(false));
        setData(tempData);
    },[rawData])

    useEffect(() => {
        let searchData = searchArrayOfObject(data, search);

        let sortedFilteredData = searchData.sort((a, b) => {
            if (!a[sortBy]) return 0;
            return a[sortBy].toLowerCase() > b[sortBy].toLowerCase()
                ? 1
                : b[sortBy].toLowerCase() > a[sortBy].toLowerCase()
                ? -1
                : 0;
        });

        if (reverseSort) {
            sortedFilteredData.reverse();
        }

        // pagination
        if (paginate === true) {
            setPageNo(0);
        }
        setSelectedRowIndex(new Array(data.length).fill(false));
        setFilteredData(sortedFilteredData);
    }, [search, data,sortBy]);

    useEffect(() => {
        if (paginate) {
            const maxPage = Math.ceil(filteredData.length / (maxRow === 0 ? 10 : maxRow));
            setMaxPage(maxPage);
            if (!isNaN(maxPage) && maxPage !== 0) {
                let paginatedData = filteredData.slice(pageNo * maxRow, pageNo * maxRow + maxRow) ;
                setDisplayData(paginatedData);
            } else {
                setDisplayData(filteredData);
            }
        } else {
            setDisplayData(filteredData);
        }
    }, [pageNo, filteredData, search]);

    function prev() {
        if (pageNo !== 0) {
            setPageNo((pn) => pn - 1);
        }
    }

    function next() {
        const maxPage = Math.ceil(filteredData.length / (maxRow === 0 ? 10 : maxRow));
        // console.log(maxPage);
        if (pageNo < maxPage - 1) {
            setPageNo((pn) => pn + 1);
        }
    }

    function toggleRow(row){
        if(selectedRowIndex[row.rowID] === true) {
            // unselect row
            setSelectedRowIndex(sri => sri.map((v,j) => j === row.rowID ? false : v));
        } else {
            // select row
            setSelectedRowIndex(sri => sri.map((v,j) => j === row.rowID ? true : v));
        }
    }
    
    useEffect(()=>{
        if(selectable){
            let selectedRowsTemp = [] ;
            selectedRowIndex.forEach((r,i) => {
                if(r === true) {
                    selectedRowsTemp.push(displayData[i]);
                }
            })
            setSelectedRows(selectedRowsTemp);
        }
    },[selectedRowIndex])

    function selectAll(){
        setSelectedRowIndex(new Array(data.length).fill(true));
    }

    function clear(){
        setSelectedRowIndex(new Array(data.length).fill(false));
    }

    return (
        <table className="table table-hover table-responsive align-middle w-100 m-0">
            <thead className="table-light text-2">
                <tr className="text-2">
                    {selectable && (
                        <th className="text-nowrap text-center" key="selectable-row" style={{width:"2rem"}}>#</th>
                    )}
                    {/* <th key={"rowID"}>
                        RowID
                    </th> */}
                    {header.map((head, i) => (
                        <th className="text-nowrap" key={i}>
                            {head.name}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {displayData.map((row, i) => (
                    <tr key={i}>
                        {selectable && (
                            <td className="text-center" key="selectable-row" style={{width:"3rem"}}>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    checked={selectedRowIndex[row.rowID] || false}
                                    onChange={() => toggleRow(row)}
                                />
                            </td>
                        )}
                    
                        {/* <td className="py-3" key={"rowID"}>
                            {row.rowID}
                        </td> */}

                        {header.map((head, j) => (
                            <td className="py-3" key={j} style={head.style}>
                                {row[head.key]}
                            </td>
                        ))}
                    </tr>
                ))}

                {displayData.length === 0 && (
                    <tr>
                        <td className="text-center" style={{ height: "4rem" }} colSpan={header.length + 1}>
                            Empty
                        </td>
                    </tr>
                )}

                {paginate && (
                    <tr>
                        <td className="text-center" style={{ height: "4rem" }} colSpan={header.length + 1}>
                            <div className="d-flex align-items-center justify-content-end">
                                {
                                    selectable && (
                                        <div className="flex-fill d-flex justify-content-start">
                                            <button onClick={selectAll} className="btn btn-primary text-white">
                                                Select All
                                            </button>
                                            <button onClick={clear} className="btn btn-primary text-white ms-2">
                                                Clear
                                            </button>
                                        </div>
                                    )
                                }
                                <button onClick={prev} className="btn btn-primary text-white" disabled={pageNo === 0}>
                                    Previous
                                </button>
                                <div className="text-black-50 mx-3">{maxPage === 0 ? 0 : pageNo + 1 } / {maxPage}</div>
                                <button
                                    onClick={next}
                                    className="btn btn-primary text-white"
                                    disabled={!(pageNo < maxPage - 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default DataTable;

/*

Data Format

header = [
    {
        name : "Name"
        key  : "myKey",
    },
    ...
]

data = {
    {
        myKey : "Hello",
        myKey2 : "world" 
    },
    ...
}

*/
